import { formatSimpleDate } from "../../../../Components/DateFn";

const MappedDeals = ({ moduleLookupData }) => {
    let tableColumn = ["Deal Name", "Amount", "Stage", "Probability (%)", "Closing Date", "Type", "Deal Owner"];

    const defaultStages = [
        { id: 1, stageName: "Qualification", probability: 10, dealCategory: "Open", forecastCategory: "Pipeline" },
        { id: 2, stageName: "Need Analysis", probability: 20, dealCategory: "Open", forecastCategory: "Pipeline" },
        { id: 3, stageName: "Value Proposition", probability: 40, dealCategory: "Open", forecastCategory: "Pipeline" },
        { id: 4, stageName: "Identify Decision Makers", probability: 60, dealCategory: "Open", forecastCategory: "Pipeline" },
        { id: 5, stageName: "Proposal/Price Quote", probability: 75, dealCategory: "Open", forecastCategory: "Pipeline" },
        { id: 6, stageName: "Negotiation/Review", probability: 90, dealCategory: "Open", forecastCategory: "Pipeline" },
        { id: 7, stageName: "Closed Won", probability: 100, dealCategory: "Closed Won", forecastCategory: "Closed" },
        { id: 8, stageName: "Closed Lost", probability: 0, dealCategory: "Closed Lost", forecastCategory: "Omitted" },
        { id: 9, stageName: "Closed Lost to Competition", probability: 0, dealCategory: "Closed Lost", forecastCategory: "Omitted" }
    ];


    return (
        <>
            <div className="bg-white border rounded-lg shadow-sm mt-1 rounded">
                <div className="col-md-12">
                    <div className="tbl-container rounded-table overflow-y-auto" style={{ maxHeight: 'calc(100vh - 21.2vh)' }}>
                        <div className="table-responsive">
                            <table className="table mb-0">
                                <thead>
                                    <tr>
                                        {tableColumn.map((data) => (
                                            <th key={data}>{data}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {moduleLookupData?.Deals && moduleLookupData?.Deals.length > 0 ? (
                                        moduleLookupData?.Deals.map((deal) => (
                                            <tr key={deal?._id}>
                                                <td>{deal?.data?.section_data?.Deal_Name}</td>
                                                <td>{deal?.data?.section_data?.Amount}</td>
                                                <td>{defaultStages?.map(stage => stage.id === Number(deal?.data?.section_data?.Stage) ? stage.stageName : null)}</td>
                                                <td>{deal?.data?.section_data?.Probability_}</td>
                                                <td>{formatSimpleDate(deal?.data?.section_data?.Closing_Date)}</td>
                                                <td>{deal?.data?.section_data?.Type}</td>
                                                <td>{deal?.data?.section_data?.Deal_Owner?.name}</td>
                                            </tr>
                                        ))
                                    ) :
                                        <tr>
                                            <td colSpan="7" className="text-center">No records found</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MappedDeals;